import { isAuthenticated, getUser } from '../utils/auth';

export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'auth/LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'auth/LOGOUT_SUCCESS';

export const loginRequest = () => ({
  type: LOGIN_REQUEST
});
export const loginSuccess = profile => ({
  type: LOGIN_SUCCESS,
  payload: { profile }
});
export const loginError = error => ({
  type: LOGIN_ERROR,
  error
});
export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS
});

// const BALANCE_FIELD = 'https://app.staker.co/token_balance';

const authReducer = (
  state = {
    isAuthenticated: isAuthenticated(),
    isFetching: false,
    profile: getUser(),
    error: null
  },
  action
) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        profile: action.payload.profile
        // availableBalance: action.payload.profile[BALANCE_FIELD]
      };
    case LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        profile: {},
        error: action.error
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        profile: {}
      };
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/App/authReducer.js